// extracted by mini-css-extract-plugin
export default {"row":"buttons__row__BeOyR","btn":"buttons__btn__aErQV","btnCopy":"buttons__btnCopy__U4Fcn","icon":"buttons__icon__cs6HN","heroRow":"buttons__heroRow__wZ5SM"};